import React from 'react'

import './Home.css'

const Product = () => {
    return (
        <div className='rows-div'>
            <div id='row1-1' className='row1'>

                <div id='box-1-1' className='box1'><h2 className='box1-heading'>Video Games</h2> <img className='box-img' src='https://images-na.ssl-images-amazon.com/images/G/15/electronics/2023/GamingMonth/GW_Category_Card_Desktop._SY608_CB588616759_.jpg' />
                    <p className='box-1-subpara'>See More</p>
                </div>


                <div className='box1'><h2 className='box1-heading'>Handpicked electronics</h2> <img className='box-img' src='https://images-na.ssl-images-amazon.com/images/G/15/OHL_Marketing/Toys/character_store_gw_desktop_758x608._SY608_CB644771408_.jpg' />
                    <p className='box-1-subpara'>See More</p>
                </div>


                <div className='box1'><h2 className='box1-heading'>Shop stylish Fashion</h2> <img className='box-img' src='https://m.media-amazon.com/images/I/518-lcih3HL._AC_SY460_.jpg' />
                    <p className='box-1-subpara'>See More</p>
                </div>

                <div style={{ height: "9rem" }}  className='box1'>
                    <h2 style={{ width: "12rem" }} id='prime-box'  className='box1-heading'>Prepare for Prime Day</h2> <img id='prime-box-img' className='box-img' src='https://images-na.ssl-images-amazon.com/images/G/15/em/pd22/xcm_em_prime_day_2022_77-caen_1787-tw7kl3bfb3-ca_en_ad%20topper_230x230._CB634314097_.jpg' />
                    <p style={{ marginTop: "-3rem" }} className='box-1-subpara'>July 11-12. Learn more</p>
                </div>


            </div>



            <div className='row2'>

                <div id='box-2-1' className='box1'><h2 className='box1-heading'>Shop our Kitchen store</h2> <img id='box-2-img' className='box-img' src='https://images-na.ssl-images-amazon.com/images/G/15/CA-hq/2022/img/BannerX_Default/XCM_CUTTLE_1451609_2462586_758x608_2X_en_CA._SY608_CB633175008_.jpg' />
                    <p className='box-1-subpara'>See More</p>
                </div>


                <div className='box1'><h2 className='box1-heading'>repurchased in Home</h2> <img id='box-2-img' className='box-img' src='https://images-na.ssl-images-amazon.com/images/G/15/CA-hq/2023/img/Home_Improvement/XCM_CUTTLE_1577774_3145100_758x608_2X_en_CA._SY608_CB588581920_.jpg' />
                    <p className='box-1-subpara'>See More</p>
                </div>


                <div className='box1'><h2 className='box1-heading'>Today's deals</h2> <img className='box-img' src='https://images-na.ssl-images-amazon.com/images/G/15/OHL_Marketing/Events/NYNY21/NYNY_DesktopCard_758x608._SY608_CB651443913_.jpg' />
                    <p className='box-1-subpara'>See More</p>
                </div>

                <div className='box1'><h2 className='box1-heading'>New releases</h2> <img className='box-img' src='https://images-na.ssl-images-amazon.com/images/G/15/PD23/Prime/xcm_em_prime_day_2022_243_usen_6299_8jow8nkkl6_ca_en_desktop_single_card_758x608._SY608_CB603263595_.jpg' />
                    <p className='box-1-subpara'>See More</p>
                </div>


            </div>

            <div className='row3'>
                <h1 id='todays-deal-txt' >Today's deal</h1>
                <div className='flex-s-box'>
                    <div className='s-box1'> <img className='s-box-img' src='https://m.media-amazon.com/images/I/41DkopyglUL._AC_SY400_.jpg' />
                        <div className='s-box-1-full-subpara' ><p className='s-box-1-subpara'>38% off</p> <p className='s-box-1-subpara-2'>With Prime</p></div>
                        <div style={{ display: "flex", flexDirection: "row" }}><h4>$99.98</h4> <h5 style={{ marginLeft: "0.3rem", marginTop: "0.1rem", color: "rgb(92, 92, 92)" }} >List Price:$̶1̶5̶9̶.̶9̶8̶</h5></div>
                        <div style={{ fontSize: "13px" }} >Invite-Only Deal -JBL Flip</div>
                    </div>

                    <div className='s-box1'> <img className='s-box-img' src='https://m.media-amazon.com/images/I/41qwVbpookL._AC_SY400_.jpg' />
                        <div className='s-box-1-full-subpara' ><p className='s-box-1-subpara'>38% off</p> <p className='s-box-1-subpara-2'>With Prime</p></div>
                        <div style={{ display: "flex", flexDirection: "row" }}><h4>$99.98</h4> <h5 style={{ marginLeft: "0.3rem", marginTop: "0.1rem", color: "rgb(92, 92, 92)" }} >List Price:$̶1̶5̶9̶.̶9̶8̶</h5></div>
                        <div style={{ fontSize: "13px" }} >Invite-Only Deal -JBL Flip</div>
                    </div>


                    <div className='s-box1'> <img className='s-box-img' src='https://m.media-amazon.com/images/I/41DwItdhtIL._AC_SY400_.jpg' />
                        <div className='s-box-1-full-subpara' ><p className='s-box-1-subpara'>38% off</p> <p className='s-box-1-subpara-2'>With Prime</p></div>
                        <div style={{ display: "flex", flexDirection: "row" }}><h4>$99.98</h4> <h5 style={{ marginLeft: "0.3rem", marginTop: "0.1rem", color: "rgb(92, 92, 92)" }} >List Price:$̶1̶5̶9̶.̶9̶8̶</h5></div>
                        <div style={{ fontSize: "13px" }} >Invite-Only Deal -JBL Flip</div>
                    </div>

                    <div className='s-box1'> <img className='s-box-img' src='https://m.media-amazon.com/images/I/51fsgB0KbDL._AC_SY400_.jpg' />
                        <div className='s-box-1-full-subpara' ><p className='s-box-1-subpara'>38% off</p> <p className='s-box-1-subpara-2'>With Prime</p></div>
                        <div style={{ display: "flex", flexDirection: "row" }}><h4>$99.98</h4> <h5 style={{ marginLeft: "0.3rem", marginTop: "0.1rem", color: "rgb(92, 92, 92)" }} >List Price:$̶1̶5̶9̶.̶9̶8̶</h5></div>
                        <div style={{ fontSize: "13px" }} >Invite-Only Deal -JBL Flip</div>
                    </div>

                    <div className='s-box1'> <img className='s-box-img' src='https://m.media-amazon.com/images/I/214-vH4V12L._AC_SY400_.jpg' />
                        <div className='s-box-1-full-subpara' ><p className='s-box-1-subpara'>38% off</p> <p className='s-box-1-subpara-2'>With Prime</p></div>
                        <div style={{ display: "flex", flexDirection: "row" }}><h4>$99.98</h4> <h5 style={{ marginLeft: "0.3rem", marginTop: "0.1rem", color: "rgb(92, 92, 92)" }} >List Price:$̶1̶5̶9̶.̶9̶8̶</h5></div>
                        <div style={{ fontSize: "13px" }} >Invite-Only Deal -JBL Flip</div>
                    </div>

                </div>


            </div>
        </div>

    )
}

export default Product
